export const UPDATE_HISTORY = "update/history";
